<div class="row page-head">
  <div class="col-md-5">
    <span>{{ 'ReasonsForMyVisit' | translateOrgSpecific }} </span>
  </div>
  <div class="col-md-7 text-center">
    <button class="btn btn-sm float-right btn-apportis-tertiary" type="submit" (click)="addReason()">
      <i class="fas fa-plus-circle" style="color: #ffffff;" aria-hidden="true"></i>
      {{'NewReason' | translateOrgSpecific}}</button>
  </div>
</div>
<hr>

<div class="modal-body">
<div class="card-data d-flex" style="height: 200px;overflow: auto;">
  <div *ngFor="let anList of patientCaseList; index as i" class="case-list">
    <div class="card" style=" cursor: pointer;padding-top: 10px;padding-bottom: 10px;"
      [ngClass]="{'highlight':anList.isHighlight,'noHighlight':!anList.isHighlight}"
      (click)="setcurrentlyClickedCardIndex(anList)" name="anList.id">
      <div class="row" style=" cursor: pointer;">
        <div class="col-md-12">
          <div style="float: left;margin-left: 10px;">
            <i class="fa fa-check-circle" aria-hidden="true"  [ngClass]="{'icon-color-heighlight':anList.isHighlight,'icon-color':!anList.isHighlight}"
            style="font-size:20px;padding-top: 20px;padding-bottom: 20px;"></i>
          </div>
          <div style="margin-left: 60px;">
            <label style="font-weight: bold;">{{anList.issueCategoryName}}</label><br>
            <label>{{anList.countyName}}, {{anList.create_ts | date: 'MMMM dd, yyyy'}}</label>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div *ngIf="patientCaseList.length == 0" class="case-list">
    {{ 'NoRecordsFound' | translateOrgSpecific }}
  </div>

</div>
</div>
<div class="modal-footer">
  <div>
    <button (click)="closeModal()" class="btn btn-sm btn-apportis-tertiary btn-cancel"
      type="submit">{{ 'Cancel' | translateOrgSpecific }}</button>

    <button class="btn btn-sm btn-apportis-tertiary " [disabled]="array.length == 0" type="submit"
      (click)="makeAppointment() ">
      <i class="fas fa-plus-circle" style="color: #ffffff;" aria-hidden="true"></i> {{btnLabel}}</button>
  </div>

</div>